import axios from "@/utils/request"
function GET_LIST(params) {
    return axios.get("/batch/Alibaba/customerInfo", {
        params: {
            ...params
        }
    })
}
function SUBMIT_ADD(params) {
    return axios.post("/batch/Alibaba/addPost", {...params})
}
function GET_RECORD(params) {
    return axios.get("/batch/Alibaba/record", {
        params: {
            ...params
        }
    })
}
function GET_NAME(params) {
    return axios.get("/batch/Alibaba/customerList", {
        params: {
            ...params
        }
    })
}
function DELE(params) {
    return axios.post("/batch/Alibaba/delete", {...params})
}
function GET_DETAIL_RECORD(params) {
    return axios.get("/batch/AlibabaDetail/record", {
        params: params
    })
}
function DETAIL_DELE(params) {
    return axios.post("/batch/AlibabaDetail/delete", {...params})
}
function DETAIL_ADDPOST(params) {
    return axios.post("/batch/AlibabaDetail/addPost", {...params})
}
export default {
    GET_LIST,
    SUBMIT_ADD,
    GET_RECORD,
    GET_NAME,
    DELE,
    GET_DETAIL_RECORD,
    DETAIL_DELE,
    DETAIL_ADDPOST
}
